export default {
    ENV: 'develop',
    // API_XDEVEL_BASES_URL: 'http://localhost:3000',
    API_XDEVEL_BASES_URL: 'https://api.xdevel.com',
    API_XDEVEL_CLIENT_ID: 'fcc0d0c4e0159db1802211778ca9820282f5226c',
    INT_ID: 32984
    // here your develop configuration
}